<template>
    <div>
        <v-row>
            <v-col>
                <v-layout align-center>
                    <h3 class="tit mr-4">
                        {{ name }}
                    </h3>
                    <p class="page-text--lg grey-6--text">({{ gender }} / {{ age }})</p>
                </v-layout>
            </v-col>
            <!-- <v-col cols="auto">
                <like-btn :params="{ _userPerson: value?._applicant, type: USER_LIKE_TYPES.USER_PERSON.value }">
                    <template #activator="{ active, toggle }">
                        <v-btn icon text small :color="active ? 'pink lighten-2' : undefined" @click.stop.prevent.capture="toggle">
                            <v-icon small>{{ active ? "mdi-heart" : "mdi-heart-outline" }}</v-icon>
                        </v-btn>
                    </template>
                </like-btn>
            </v-col> -->
            <v-col cols="auto">
                <like-btn :params="{ _userPerson: value?._applicant, type: USER_LIKE_TYPES.BLACKLISTED.value }">
                    <template #activator="{ active, toggle }">
                        <v-btn icon text small :color="active ? 'red' : undefined" @click.stop.prevent.capture="toggle">
                            <v-icon small>{{ active ? "mdi-account-cancel" : "mdi-account-cancel-outline" }}</v-icon>
                        </v-btn>
                    </template>
                </like-btn>
            </v-col>
            <v-col cols="auto">
                <like-btn :params="{ _application: value?._id, type: USER_LIKE_TYPES.APPLICATION.value }">
                    <template #activator="{ active, toggle }">
                        <v-btn icon text small :color="active ? 'yellow darken-1' : undefined" @click.stop.prevent.capture="toggle">
                            <v-icon>{{ active ? "mdi-star" : "mdi-star-outline" }}</v-icon>
                        </v-btn>
                    </template>
                </like-btn>
            </v-col>
        </v-row>
    </div>
    <!-- <v-card-title class="px-0">
        <span class="font-size-36">
            {{ name }} <span class="font-size-20 font-weight-regular text--secondary">({{ gender }} / {{ age }})</span>
        </span>
        <like-btn :params="{ _userPerson: value?._applicant, type: USER_LIKE_TYPES.USER_PERSON.value }">
            <template #activator="{ active, toggle }">
                <v-btn icon text small :color="active ? 'pink lighten-2' : undefined" @click.stop.prevent.capture="toggle">
                    <v-icon small>{{ active ? "mdi-heart" : "mdi-heart-outline" }}</v-icon>
                </v-btn>
            </template>
        </like-btn>
        <like-btn :params="{ _userPerson: value?._applicant, type: USER_LIKE_TYPES.BLACKLISTED.value }">
            <template #activator="{ active, toggle }">
                <v-btn icon text small :color="active ? 'red' : undefined" @click.stop.prevent.capture="toggle">
                    <v-icon small>{{ active ? "mdi-account-cancel" : "mdi-account-cancel-outline" }}</v-icon>
                </v-btn>
            </template>
        </like-btn>
        <v-spacer />
        <like-btn :params="{ _application: value?._id, type: USER_LIKE_TYPES.APPLICATION.value }">
            <template #activator="{ active, toggle }">
                <v-btn icon text :color="active ? 'yellow darken-1' : undefined" @click.stop.prevent.capture="toggle">
                    <v-icon>{{ active ? "mdi-star" : "mdi-star-outline" }}</v-icon>
                </v-btn>
            </template>
        </like-btn>
    </v-card-title> -->
</template>

<script>
import dayjs from "dayjs";
import { GENDERS, USER_LIKE_TYPES } from "@/assets/variables";

import LikeBtn from "@/components/client/like/like-btn.vue";

export default {
    components: {
        LikeBtn,
    },
    props: {
        value: { type: Object, default: () => ({}) },
    },
    data: () => ({
        USER_LIKE_TYPES,
    }),
    computed: {
        name() {
            return this.value?.resume?.personalInformation?.name;
        },
        gender() {
            return GENDERS[this.value?.resume?.personalInformation?.gender]?.text;
        },
        age() {
            let { bornAt } = this.value?.resume?.personalInformation || {};
            if (bornAt) bornAt = `${dayjs().diff(bornAt, "year")}세`;
            return bornAt;
        },
    },
};
</script>

<style>
</style>